@if (alerts.length) {
  <div class="alert-container" style="position: fixed; z-index: 11000; top: 1.5rem; right: 1.5rem; width: auto; min-width: 320px; max-width: 450px;">
    @for (alert of alerts; track alert) {
      <div class="mb-3 animate__animated animate__fadeInRight">
        <ejs-message [severity]="getSeverity(alert)" [content]="alert.message" [showCloseIcon]="true" (closed)="removeAlert(alert)" class="shadow-lg"></ejs-message>
      </div>
    }
  </div>
}
